import { createContext } from "react";

// {handleLogout}: the site sign-in (App.jsx SiteAuthProvider). Its own module so the phone
// shell can sign out without importing App.jsx.
export const SiteAuthContext = createContext(null);
